import React from "react";

const EmployeeSkills = () => {
  return <div>Employee Skills</div>;
};

export default EmployeeSkills;
